<button (click)="onTissuesPHeChartClick()" class="graph mat-elevation-z2">
  <div id="tissues-phe-chart" class="plotly-graph" [class]="getGraphClass()"></div>
  <div *ngIf="!getShowGraphs()">Create dive segements to populate graphs</div>
</button>
